import { useQuery } from "@tanstack/react-query";
import { contentService } from "@/features/content/services/contentService";
import type { ContentListParams } from "@/features/content/services/contentService";
import { queryKeys } from "@/lib/query-keys";

const CONTENT_TYPE = "pages";

interface UseDepartmentPagesOptions {
  departmentId?: string;
  unassigned?: boolean;
  pageSize?: number;
  enabled?: boolean;
}

export function useDepartmentPages(options: UseDepartmentPagesOptions) {
  const { departmentId, unassigned, pageSize = 10, enabled } = options;

  const params: ContentListParams = {
    contentType: CONTENT_TYPE,
    pageSize,
    ...(unassigned ? { unassigned: true } : { departmentId }),
  };

  const isEnabled =
    enabled ??
    (unassigned ? true : Boolean(departmentId));

  return useQuery({
    queryKey: queryKeys.content.list(params),
    queryFn: () => contentService.list(params),
    enabled: isEnabled,
  });
}

export { CONTENT_TYPE as DEPARTMENT_PAGES_CONTENT_TYPE };
